import { mountRaceList } from './utils/mount-race-list.js';
import { STATE_URL } from './constants.js';
import { called_statewide_races } from './close_races.js';

// Statewide offices, in this order: Lt. Governor, Secretary of State,
// Controller, Treasurer, Attorney General, Insurance Commissioner,
// Superintendent of Public Instruction
mountRaceList('uncalled-ca-statewide-races', STATE_URL, {
  filter: [
    {
      offices: ['L', 'SS', 'C', 'T', 'A', 'CI', 'SUE'],
      sort: 'offices',
      excludeIds: called_statewide_races,
    },
    {
      offices: ['BOE'],
      sort: 'seat',
      excludeIds: called_statewide_races,
    },
  ],
  component: 'result',
  captions: {
    'CA-84270': 'Board of Equalization, Seat 1',
    'CA-84279': 'Board of Equalization, Seat 2',
    'CA-84269': 'Board of Equalization, Seat 3',
    'CA-84278': 'Board of Equalization, Seat 4',
  },
}).catch(console.error);
